import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { DeleteByIdPayload, DeleteExternalConnectionInput } from '../gql-types.generated';

export const MUTATION_DELETE_EXTERNAL_CONNECTION = gql`
    mutation deleteExternalConnection($input: DeleteExternalConnectionInput!){
        deleteExternalConnection(input: $input){
            message
            result
            errors {
                code
                message
            }
        }
    }
`;

export const mutationDeleteExternalConnection = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: {
        externalConnectionType: string;
    }
): Promise<DeleteByIdPayload | undefined> => {
    const { externalConnectionType } = args as DeleteExternalConnectionInput;
    const { data, errors } = await client.mutate<{ deleteExternalConnection: DeleteByIdPayload }>({
        variables: {
            input: {
                externalConnectionType
            }
         },
        mutation: MUTATION_DELETE_EXTERNAL_CONNECTION
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // friendly error to user
        throw new Error('An error has occurred during the external connection delete.');
    }
    if (data && data.deleteExternalConnection) {
        return data.deleteExternalConnection;
    }

    return undefined;
};
